import React, { useEffect, useState } from 'react';
import { FallbackImage } from '../utils';

/**
 * Loading screen component that shows while the site is initializing
 * @category Site Elements
 * @function LoadingScreen
 * @returns {jsx}
 */
export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Function to update progress based on document readyState
    const updateProgress = () => {
      switch (document.readyState) {
        case 'loading':
          setProgress(30);
          break;
        case 'interactive':
          setProgress(60);
          break;
        case 'complete':
          setProgress(100);
          break;
        default:
          setProgress(0);
      }
    };

    // Initial progress update
    updateProgress();

    // Listen for readystatechange events
    document.addEventListener('readystatechange', updateProgress);

    return () => {
      document.removeEventListener('readystatechange', updateProgress);
    };
  }, []);

  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-icon">
          <figure className="image is-128x128">
            <FallbackImage styleName="lazyload" />
          </figure>
        </div>
        <div className="loading-progress">
          <div 
            className="progress-bar" 
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
} 